import { __read, __spread } from "tslib";
import { empty, merge, queueScheduler } from 'rxjs';
import { mergeMap, observeOn, subscribeOn } from 'rxjs/operators';
export function createOutputStream(action$, stores) {
    var deps = { action$: action$ };
    return action$.pipe(subscribeOn(queueScheduler), observeOn(queueScheduler), mergeMap(function (sourceAction) {
        var handlers = stores
            .map(function (store) { return store.getOutputStream(sourceAction, deps); })
            .filter(function (handler) { return handler !== null; })
            .reduce(function (ret, arr) { return __spread(ret, arr); }, []);
        if (handlers.length === 0) {
            return empty();
        }
        else {
            return merge.apply(void 0, __spread(handlers));
        }
    }));
}
//# sourceMappingURL=createOutputStream.js.map